import { render, staticRenderFns } from "./itinerary_air_alternative.vue?vue&type=template&id=ec55c352&scoped=true&"
import script from "./itinerary_air_alternative.vue?vue&type=script&lang=js&"
export * from "./itinerary_air_alternative.vue?vue&type=script&lang=js&"
import style0 from "./itinerary_air_alternative.vue?vue&type=style&index=0&id=ec55c352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec55c352",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260521091304/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec55c352')) {
      api.createRecord('ec55c352', component.options)
    } else {
      api.reload('ec55c352', component.options)
    }
    module.hot.accept("./itinerary_air_alternative.vue?vue&type=template&id=ec55c352&scoped=true&", function () {
      api.rerender('ec55c352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/itineraries/itinerary_air_alternative.vue"
export default component.exports